module.exports = __webpack_public_path__ + "images/pages/lp/lens_3_33aed1ecbcfc0c1c1b70877072e409fa.png";